/**
 * Symbol.observable polyfill for Redux compatibility
 * This prevents the warning about Symbol.observable mismatch between Redux and Redux DevTools
 */

// Only polyfill if Symbol.observable doesn't exist
if (typeof Symbol !== 'undefined' && !Symbol.observable) {
  Symbol.observable = Symbol('observable')
}

// Export for potential use in other modules
export default Symbol.observable
